// Copyright text placeholder, Warner Bros. Discovery, Inc.

/**
 *  WARNING:
 *  This file is auto-generated. Do not edit manually. Any changes made to this
 *  file will be overwritten the next time it is generated. If you need to make
 *  changes, please modify the source files and re-generate this file.
 */

import { BaseEvent, IVersionedEvent } from '../../../core';

/**
 * enum of start mark
 * @public
 * @readonly
 */

enum StartMarkNameV1 {
  /** StartMarkName of BOOT_START **/
  BOOT_START = 'BOOT_START',
  /** StartMarkName of BOOT_END **/
  BOOT_END = 'BOOT_END',
  /** StartMarkName of PAGE_ROUTE_CHANGED **/
  PAGE_ROUTE_CHANGED = 'PAGE_ROUTE_CHANGED',
  /** StartMarkName of SPLASH_SCREEN_REMOVED **/
  SPLASH_SCREEN_REMOVED = 'SPLASH_SCREEN_REMOVED',
  /** StartMarkName of PAGE_DATA_LOAD_START **/
  PAGE_DATA_LOAD_START = 'PAGE_DATA_LOAD_START',
  /** StartMarkName of PAGE_DATA_LOAD_END **/
  PAGE_DATA_LOAD_END = 'PAGE_DATA_LOAD_END'
}
/**
 * enum of end mark
 * @public
 * @readonly
 */

enum EndMarkNameV1 {
  /** EndMarkName of BOOT_START **/
  BOOT_START = 'BOOT_START',
  /** EndMarkName of BOOT_END **/
  BOOT_END = 'BOOT_END',
  /** EndMarkName of PAGE_ROUTE_CHANGED **/
  PAGE_ROUTE_CHANGED = 'PAGE_ROUTE_CHANGED',
  /** EndMarkName of SPLASH_SCREEN_REMOVED **/
  SPLASH_SCREEN_REMOVED = 'SPLASH_SCREEN_REMOVED',
  /** EndMarkName of PAGE_DATA_LOAD_START **/
  PAGE_DATA_LOAD_START = 'PAGE_DATA_LOAD_START',
  /** EndMarkName of PAGE_DATA_LOAD_END **/
  PAGE_DATA_LOAD_END = 'PAGE_DATA_LOAD_END'
}
/**
 * The name of the measure
 * @public
 * @readonly
 */

enum NameV1 {
  /** Name of BOOT **/
  BOOT = 'BOOT',
  /** Name of PAGE_DATA_LOAD **/
  PAGE_DATA_LOAD = 'PAGE_DATA_LOAD',
  /** Name of FIRST_CONTENTFUL_PAINT **/
  FIRST_CONTENTFUL_PAINT = 'FIRST_CONTENTFUL_PAINT',
  /** Name of LARGEST_CONTENTFUL_PAINT **/
  LARGEST_CONTENTFUL_PAINT = 'LARGEST_CONTENTFUL_PAINT',
  /** Name of TIME_TO_INTERACTIVE **/
  TIME_TO_INTERACTIVE = 'TIME_TO_INTERACTIVE',
  /** Name of FIRST_INPUT_DELAY **/
  FIRST_INPUT_DELAY = 'FIRST_INPUT_DELAY'
}

/**
 *
 *
 * version 1.0
 * @public
 */
interface IStartPageV1 {
  /** The relative url of the page. **/
  uri: string;
  /** Canonical pageId of the currently rendered page. Canonical pageIds must be consistent across all implementations of Beam; we achieve this by using CMS-provided values where possible. **/
  id?: string;
}

/**
 *
 *
 * version 1.0
 * @public
 */
interface IStartMarkV1 {
  /** enum of start mark **/
  name: StartMarkNameV1;
  /**  **/
  page: IStartPageV1;
}

/**
 *
 *
 * version 1.0
 * @public
 */
interface IEndPageV1 {
  /** The relative url of the page. **/
  uri: string;
  /** Canonical pageId of the currently rendered page. Canonical pageIds must be consistent across all implementations of Beam; we achieve this by using CMS-provided values where possible. **/
  id?: string;
}

/**
 *
 *
 * version 1.0
 * @public
 */
interface IEndMarkV1 {
  /** enum of end mark **/
  name: EndMarkNameV1;
  /**  **/
  page: IEndPageV1;
}

/**
 *
 *
 * version 1.0
 * @public
 */
interface IMeasureV1Payload {
  /** unix timestamp when the measure was ended on the client device. If end mark is not null, this should match the deviceOccurredAt of the end mark. **/
  deviceEndedAt: number;
  /** unix timestamp when the measure was started on the client device. This should always match the deviceOccurredAt of the start mark. **/
  deviceStartedAt: number;
  /** Milliseconds in duration for the measure. delta between the deviceStartedAt and the deviceEndedAt in milliseconds, OR can use an internal startedAtTimestamp and endedAtTimestamp on some devices (web) for greater accuracy using **/
  duration: number;
  /** The name of the measure **/
  name: NameV1;
  /**  **/
  startMark: IStartMarkV1;
  /**  **/
  endMark?: IEndMarkV1;
}

/**
 * PerformanceMeasureV1 event
 * An event emitted when a client instruments a measure. Signifies the duration in MS for how long it took for the measure to happen.
 * @public
 */
export class PerformanceMeasureV1 extends BaseEvent<IMeasureV1Payload> {
  /** unique event type **/
  public readonly eventType: string = 'beam.events.performance.measure_1.0';
  /** enum of start mark **/
  public static START_MARK_NAME: typeof StartMarkNameV1 = StartMarkNameV1;
  /** enum of end mark **/
  public static END_MARK_NAME: typeof EndMarkNameV1 = EndMarkNameV1;
  /** The name of the measure **/
  public static NAME: typeof NameV1 = NameV1;

  /**
   * overrides the default _build method to add default values for fields
   * @param payload - The payload for this event.
   * @returns IVersionedEvent<IMeasureV1Payload>
   */
  protected override _build(payload: IMeasureV1Payload): IVersionedEvent<IMeasureV1Payload> {
    return super._build({
      ...payload
    });
  }
}

export { StartMarkNameV1 as PerformanceMeasureV1StartMarkName };
export { EndMarkNameV1 as PerformanceMeasureV1EndMarkName };
export { NameV1 as PerformanceMeasureV1Name };
export type { IStartPageV1 as IPerformanceMeasureV1StartPage };
export type { IStartMarkV1 as IPerformanceMeasureV1StartMark };
export type { IEndPageV1 as IPerformanceMeasureV1EndPage };
export type { IEndMarkV1 as IPerformanceMeasureV1EndMark };
export type { IMeasureV1Payload as IPerformanceMeasureV1Payload };
